import React, { useEffect, useState } from "react";
import { Button, IconCheckCircle, IconXCircle, Table, Tooltip, Tabs, Modal,FilePicker } from "@veneer/core";
import { Row, Col, Container } from 'react-bootstrap';
import Swal from "sweetalert2";
import ConnectAPI from '../../services/api';
import { useTranslation } from "react-i18next";
import $, { data, map } from 'jquery';
import { downloadFile } from "../../services/FileDownloader/FileDownloader";

function TableDataUpload({ onShowModal, idelement, onCloseSCDetailsModal, successupload, NameElement}) {
    const [t, i18n] = useTranslation();
    const connectApi = new ConnectAPI();
    const [loadingbtn, setloadingbtn]=useState(false);
    const [File,setFile]=useState(null);
    const [btnEnable,setbtnEnable]=useState(true);
    const [typeelement, settypeelement]=useState("");
    function handleChange(event) {
        setFile(event.target.files[0])
        setbtnEnable(false);
    }
    useEffect(()=>{
        if (idelement){
            connectApi
            .get("api/Channels/getcontenttab",
            {
                params:{
                    payload: idelement
                }
            }
            ,consolid)
            .catch((error) => {
                console.log(error);
                Swal.fire(
                    "Error " + error?.response?.status,
                    error?.response?.data,
                    "error"
                );
            });
        }
        
    },[idelement]);
    const consolid = (status, data) => {
        settypeelement(data.typeElement);
    }
    function downloaddata(){
        setloadingbtn(true);
        connectApi.get(
            "api/Channels/GenerateStep",
            {
                params:{
                    payload: idelement
                }
            }
            ,
            ProcResult
        ).catch((error) => {
            setloadingbtn(false);
            onCloseSCDetailsModal();
            Swal.fire(
                "Error " ,
                error?.response?.data,
                "error"
            );
        });
    }
    function submit(){
        setloadingbtn(true);
        let data = new FormData();
        data.append("file", File);
        data.append("element",idelement);
        connectApi.post(
            "api/Channels/UploadFiles",
            data,
            handleReloadData
        ).catch((error) => {
            setloadingbtn(false);
            onCloseSCDetailsModal();
            Swal.fire(
                "Error " ,
                error?.response?.data,
                "error"
            );
        });
    }
    const ProcResult=(status,data)=>{
        downloadFile(data);
        setloadingbtn(false);
        successupload();
    }
    const handleReloadData = (status,data) => {
        if (status==200){
            setloadingbtn(false);
            $("#Files").val("");
            $(".vn-input__file").html("");
            $(".vn-input__file").attr("title","")
            setFile(null);
            successupload();
        }else{
            loadingbtn(false);
            Swal.fire(
                "Error " + data.status,
                data.data,
                "error"
            );
        }
    }
    return (
        <>
             <Modal
                id="regular-modal"
                onClose={() => { onCloseSCDetailsModal(); }}
                show={onShowModal}
                title={t("Data Upload")+" "+NameElement}
            >
                {(typeelement=="download")?(
                    <Button
                    loading={loadingbtn}
                    onClick={downloaddata}
                    >{t("download data")}</Button>
                ):(
                    <>
                        <FilePicker 
                        id="Files"
                        accept=".xlsx,.xls,.csv"
                        onChange={handleChange}
                        />
                        <br/>
                        <Button
                        loading={loadingbtn}
                        onClick={submit}
                        disabled={btnEnable}
                        >{t("send")}</Button>
                    </>
                )}
                
            </Modal>
        </>
    );
}
export default TableDataUpload;